/* NOTE: Please do not edit these files which have been added to support Payment Iframe integration.
They are temporary and will be replaced by package once it's available */
// Define the IFRAME_CONFIG to specify environment URLs and identifiers
const IFRAME_CONFIG = {
  environments: {
    local: { url: 'http://localhost:3000' },
    preview_ELZ: { url: 'https://ent-fin-cc-ui-preview.sbx.ent-aong-01.aws.ent.af1platform.com' },
    dev: { url: 'https://ent-fin-cc-ui.pci-dev.homesitep2.com' },
    dev_ELZ: { url: 'https://ent-fin-cc-ui-dev.sbx.ent-aong-01.aws.ent.af1platform.com' },
    qa: { url: 'https://ent-fin-cc-ui.pci-qa.homesitep2.com' },
    qa_ELZ: { url: 'https://ent-fin-cc-ui-qa.preprod.ent-aong-01.aws.ent.af1platform.com' },
    staging: { url: 'https://ent-fin-cc-ui.pci-uat.homesitep2.com' },
    staging_ELZ: {
      url: 'https://ent-fin-cc-ui-staging.preprod.ent-aong-01.aws.ent.af1platform.com'
    },
    prod: { url: '' }
  },
  parentIdentifier: 'ENT_FIN_ENTRY_PARENT',
  iframeIdentifier: 'ENT_FIN_ENTRY_IFRAME'
};

const IncomingMessageTypeEnum = {
  ALL_10_IFRAME_APP_LOADED: 'ALL_10_IFRAME_APP_LOADED',
  AFE_20_FORM_VALIDATION_STATUS: 'AFE_20_FORM_VALIDATION_STATUS',
  AFE_41_AFE_TOKEN_SUCCESS: 'AFE_41_AFE_TOKEN_SUCCESS',
  AFE_42_AFE_TOKEN_FAILURE: 'AFE_42_AFE_TOKEN_FAILURE'
};
const OutgoingMessageTypeEnum = {
  AFE_40_AFE_TOKEN_REQUEST: 'AFE_40_AFE_TOKEN_REQUEST',
  AFE_30_DISABLE_FIELDS_REQUEST: 'AFE_30_DISABLE_FIELDS_REQUEST'
};

class AfeFinancialEntryAdapter {
  static debug = false;

  constructor(config) {
    this.afeSessionId = config.afeSessionId;
    this.debug = config.debug ?? false;
    this.log = config.loggingMethod || this._defaultLogger.bind(this);

    // Assign event handlers
    this.onTokenSuccess = config.onTokenSuccess;
    this.onTokenFailure = config.onTokenFailure;
    this.onValidation = config.onValidation;
    this.onLoadComplete = config.onLoadComplete;

    // Determine iframe origin from environment
    this.iframeOrigin = IFRAME_CONFIG.environments[config.environment].url;

    // Validate required configurations
    if (!this.iframeOrigin || !IFRAME_CONFIG.iframeIdentifier || !IFRAME_CONFIG.parentIdentifier) {
      throw new Error(
        'Missing required configuration for iframeOrigin, iframeIdentifier, or parentIdentifier.'
      );
    }

    this._createIframe(config);

    // Build the iframe URL
    const url = this._buildIframeUrl(config.expId, config.paymentMethod);
    this.frame.src = url;

    // Set up a listener for incoming messages
    window.addEventListener('message', this._processIncomingMessage.bind(this));
  }

  _defaultLogger(...args) {
    if (this.debug) console.log(...args);
  }

  _createIframe(config) {
    this.frame = document.createElement('iframe');

    // Set the iframe properties using the config parameter
    this.frame.id = config.iframeId ?? '';
    this.frame.name = config.iframeName ?? '';
    this.frame.classList.add(...(config.iframeClassArray ?? []));

    // Obtain the iframe container using the id from config
    const iframeContainer = document.getElementById(config.iframeContainerId);
    if (!iframeContainer)
      throw new Error(`Iframe container with id '${config.iframeContainerId}' not found.`);

    // Append the new iframe to the container
    iframeContainer.appendChild(this.frame);
  }

  _buildIframeUrl(expId, paymentMethod) {
    // Set the iframe source URL
    let url = `${this.iframeOrigin}?exp-id=${expId}&afe-session-id=${this.afeSessionId}&${paymentMethod && `paymentMethod=${paymentMethod}`}`;
    if (this.debug) url += `&debug=${this.debug}`;

    if (process.env.NODE_ENV !== 'production') {
      this.log('Parent: Loading frame', { url });
    }

    return url;
  }

  destroy() {
    if (process.env.NODE_ENV !== 'production') {
      this.log("Parent: Destroying Parent's AfeFinancialEntryAdapter");
    }

    // Remove message listener and iframe element
    window.removeEventListener('message', this._processIncomingMessage.bind(this), false);
    if (this.frame && this.frame.parentNode) {
      this.frame.parentNode.removeChild(this.frame);
    }
  }

  _postMessage(messageType, message) {
    this.log(`P -> I - Sending ${messageType}`);
    const json_message = {
      source: IFRAME_CONFIG.parentIdentifier,
      target: IFRAME_CONFIG.iframeIdentifier,
      messageType,
      message
    };

    // Post message to the iframe
    this.frame.contentWindow?.postMessage(json_message, this.iframeOrigin);
  }

  _processIncomingMessage(event) {
    const { origin: eventOrigin, data } = event;
    const { source, target, messageType, message } = data;

    this.log(
      `P <- I - Receiving ${messageType} (origin: ${eventOrigin}, source: ${source}, target: ${target})`
    );

    if (eventOrigin !== this.iframeOrigin) return; // Ensure that the message is coming from the iframe
    if (source !== IFRAME_CONFIG.iframeIdentifier) return; // Ensure that the message source identifier is the iframe
    if (target !== IFRAME_CONFIG.parentIdentifier) return; // Ensure that the message target identifier is this parent's identifier'

    switch (messageType) {
      case IncomingMessageTypeEnum.ALL_10_IFRAME_APP_LOADED: {
        if (this.onLoadComplete) this.onLoadComplete(message);
        break;
      }
      case IncomingMessageTypeEnum.AFE_20_FORM_VALIDATION_STATUS: {
        if (this.onValidation) this.onValidation(message.isFormValid);
        break;
      }
      case IncomingMessageTypeEnum.AFE_41_AFE_TOKEN_SUCCESS: {
        const afeTokenObj = message || {};
        if (!afeTokenObj || typeof afeTokenObj !== 'object') {
          this.log(`AFE Token 'afeTokenObj'. Message: `, message);
          return;
        }
        if (this.onTokenSuccess) this.onTokenSuccess(afeTokenObj);
        break;
      }
      case IncomingMessageTypeEnum.AFE_42_AFE_TOKEN_FAILURE: {
        const { errorMsg } = message || {};
        if (!errorMsg || typeof errorMsg !== 'string') {
          this.log(`ERROR: Invalid 'errorMsg'. Message: `, message);
          return;
        }
        if (this.onTokenFailure) this.onTokenFailure(errorMsg);
        break;
      }
      default: {
        this.log(`ERROR: Unrecognized messageType '${messageType}'. Message: `, message);
        break;
      }
    }
  }

  getToken(params) {
    if (process.env.NODE_ENV !== 'production') {
      this.log(`Parent Action: Requesting AFE Token from iframe`);
    }

    // Send a message to request the AFE token
    this._postMessage(OutgoingMessageTypeEnum.AFE_40_AFE_TOKEN_REQUEST, params);
  }

  setDisableFields(disabled) {
    if (process.env.NODE_ENV !== 'production') {
      this.log(`Parent Action: Requesting Disable FormFields`);
    }

    // Send a message to request the AFE token
    this._postMessage(OutgoingMessageTypeEnum.AFE_30_DISABLE_FIELDS_REQUEST, { disabled });
  }
}

export default AfeFinancialEntryAdapter;
